import { DBConnectorService } from './../../../service/test.service';
import { SectorModel } from './../../../service/sector.model';
import { ManageService } from '../../../service/manage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
// import { DialogService } from 'ng2-bootstrap-modal';
import { Component, OnInit, EventEmitter } from '@angular/core';
export interface ExcelModal {
  // title: string;
  // message: string;
}

@Component({
  selector: 'app-view-excel-modal',
  templateUrl: './view-excel-modal.component.html',
  styleUrls: ['./view-excel-modal.component.css']
})
export class ViewExcelModalComponent  implements ExcelModal,OnInit {
  public event: EventEmitter<boolean> = new EventEmitter();  
  // title: string;
  // message: string;
  ErrorCount: number;
  ProCount: number;
  result1: any ={};
  sectormodel = new SectorModel;
  constructor(private bsModalRef: BsModalRef,
  private manage: ManageService,
  private dbconnectorservice: DBConnectorService) {
    //super(dialogService);
    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
  }

  showExcel(){

    this.manage.ShowExcelFiles(this.sectormodel)
      .subscribe(
      (data) => {
        this.result1 = data;
        //console.log(this.result1);
        this.ProCount = this.result1["processedFiles"].length;
        this.ErrorCount = this.result1["errorFiles"].length;
      });
  }
  

  confirm() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code 
    // this.result = true;
    // this.close();
    this.event.emit(true)
    this.closeModal()
  }

  closeModal() {
    //this.close()
    this.bsModalRef.hide()
  }

  ngOnInit(){

    this.showExcel();
  }
}

